module.exports = __webpack_public_path__ + "img/156.14df9133.png";